module.exports = [{
      plugin: require('/usr/src/app/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
